import { Injector, OnInit, HostListener, Component } from '@angular/core';
import { AppComponentBase } from './app-component-base';

export class PagedResultDto {
  items: any[] = [];
  totalCount: number = 0;
}

export class EntityDto {
  id: number = 0;
}

export class PagedRequestDto {
  skipCount: number = 0;
  maxResultCount: number = 0;
}

@Component({
  template: '',
})
export abstract class PagedListingComponentBase
  extends AppComponentBase
  implements OnInit
{
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public totalPages: number = 1;
  public totalItems: number = 0;
  public gridSummary!: string;
  public isTableLoading = false;
  filterValueArray: Map<string, string> = new Map<string, string>();
  filterValue: string = '';
  filterOption: string = '';

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  refreshPage() {
    this.pageNumber = 1;
    this.totalPages = 1;
  }

  refresh(): void {
    this.getData();
  }

  onPageChange(value: any) {
    this.pageNumber = value ? value : 1;
    this.refresh();
  }

  abstract getFilterOption(url: string): string;

  abstract getData(): any;

  calculateTotalPages() {
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
  }
}
